





































import Vue from 'vue';
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import { t } from "@/plugins/i18n";

interface Data {
  localItems: any[];
}

type DownloadableInvoice = any;
type DownloadableInvoiceItem = any;

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    MoneyDisplay,
  },

  props: {
    head: { type: Object as () => DownloadableInvoice }
  },

  data() {
    return {
      localItems: [],
    }
  },

  beforeMount() {
    this.localItems = this.$props.head.items;
  },

  computed: {
    columns: () => [
      {
          field: "id",
          title: t("Azonosito")
      },
      {
          field: "itemName",
          title: t("Nev")
      },
      {
          field: "itemNo",
          title: t("Cikkszam")
      },
      {
          field: "unitPrice",
          title: t("Egysegar"),
          cell: "unitPriceTemplate",
          headerClassName: "right_text"
      },
      {
          field: "amount",
          title: t("Mennyiseg"),
          cell: "amountTemplate",
          headerClassName: "right_text"
      },
      {
          field: "netto",
          title: t("Netto"),
          cell: "nettoTemplate",
          headerClassName: "right_text"
      },
      {
          field: "vat",
          title: t("Afa"),
          cell: "vatTemplate",
          headerClassName: "right_text"
      },
      {
          field: "total",
          title: t("Brutto"),
          cell: "totalTemplate",
          headerClassName: "right_text"
      },
    ]
  },
})
